import { useEffect } from 'react'

import { useHistory } from 'react-router-dom'
import { TypesRoutes } from 'routes/mixedRoutes/types'
import { useNavBar } from 'hooks/useNavBar'
import { Button, Text } from 'components/InterUI/InterUI'
import { Icons } from 'utils/icons'
import RepurchaseHero from 'assets/png/repurchase_hero.png'
import useBoundState from 'store'
import BaseBridge from 'config/bridge/BaseBridge'

import * as S from './RepurchaseIncentive.styles'
import {
  analyticsRepurchaseIncentiveLoad,
  analyticsConfirmRepurchaseIncentiveTag,
  analyticsDismissRepurchaseIncentiveTag,
  analyticsRepurchaseIncentivePage,
} from './RepurchaseIncentive.tags'

export const RepurchaseIncentive = () => {
  const history = useHistory()
  const tickets = useBoundState((state) => state.tickets)
  const contentCapitalization = useBoundState((state) => state.contentCapitalization)
  const contentTitle = useBoundState((state) => state.contentTitle)
  const monitoring = useBoundState((state) => state.monitoring)

  const features = [
    {
      id: 1,
      icon: <Icons.HandMoney width={24} height={24} color="var(--gray500)" />,
      description: `50% do valor que você pagou no seu ${contentTitle.value1Lowercase} está disponível para resgate`,
    },
    {
      id: 2,
      icon: <Icons.HandCoin width={24} height={24} color="var(--gray500)" />,
      description: 'Utilize esse valor para ter mais 16 chances de ganhar R$ 7.000,00',
    },
    {
      id: 3,
      icon: <Icons.CoinAdd width={24} height={24} color="var(--gray500)" />,
      description: 'E mais: nova chance de ganhar até R$ 100,00 na hora',
    },
  ]

  useNavBar({
    backListener: () => BaseBridge.requestGoBack(),
  })

  const redemptionAmount = tickets.totalRedemptionAmount ?? 0

  useEffect(() => {
    analyticsRepurchaseIncentivePage()
    analyticsRepurchaseIncentiveLoad()
    monitoring({
      eventName: 'load_repurchase_incentive',
      params: { redemption_amount: `${redemptionAmount}` },
    })
  }, [])

  const handleConfirm = () => {
    analyticsConfirmRepurchaseIncentiveTag()
    monitoring({
      eventName: 'confirm_repurchase_incentive',
      params: { redemption_amount: `${redemptionAmount}` },
    })
    history.push(TypesRoutes.REPURCHASE)
  }

  const handleDismiss = () => {
    analyticsDismissRepurchaseIncentiveTag()
    monitoring({
      eventName: 'dismiss_repurchase_incentive',
      params: { redemption_amount: `${redemptionAmount}` },
    })
    history.push(TypesRoutes.LANDING_PAGE_HOME)
  }

  return (
    <S.Container data-testid="repurchase-incentive-container">
      <S.HeroContainer>
        <S.HeroImage
          src={RepurchaseHero}
          alt="Repurchase Gift"
          data-testid="repurchase-gift-image"
        />
      </S.HeroContainer>
      <S.Content>
        <Text variant="headline-h1" semiBold weight={600}>
          Resgate disponível! Quer renovar suas chances?
        </Text>

        <S.FeatureList data-testid="feature-list">
          {features.map((feature) => (
            <S.FeatureItem key={feature.id} data-testid={`feature-item-${feature.id}`}>
              <S.IconWrapper>{feature.icon}</S.IconWrapper>
              <Text variant="body-3" colorWeight={400}>
                {feature.description}
              </Text>
            </S.FeatureItem>
          ))}
        </S.FeatureList>
      </S.Content>
      <S.Footer>
        <Button data-testid="confirm-button" fullWidth onClick={handleConfirm}>
          Garantir nova {contentCapitalization.value1}
        </Button>
        <Button data-testid="dismiss-button" fullWidth variant="secondary" onClick={handleDismiss}>
          Agora não
        </Button>
      </S.Footer>
    </S.Container>
  )
}
